import { DestroyRef, Directive, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IIKOTableGridComponent } from '../iiko-table-grid/iiko-table-grid.component';
import { BehaviorSubject, combineLatest, tap } from 'rxjs';
import { ColumnDefinition, Filter } from 'tabulator-tables';

@Directive({
  selector: '[restoTableGridPlainTableSearchString]',
})
export class PlainTableSearchStringDirective implements OnInit {
  /** A search string to filter rows in the table */
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('restoTableGridPlainTableSearchString') set searchString(value: string) {
    this._onSetSearchTable$$.next(value);
  }

  destroyRef = inject(DestroyRef);

  private _onSetSearchTable$$ = new BehaviorSubject<string | undefined>(undefined);

  constructor(private tableGridComponent: IIKOTableGridComponent) {}

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    combineLatest([this._onSetSearchTable$$, this.tableGridComponent.onSetColumnDefs$])
      .pipe(
        tap(([searchString, columnDefs]: [string | undefined, ColumnDefinition[]]) => {
          if (!searchString) {
            this.tableGridComponent.clearFilter(false);
            return;
          }

          const filter: Filter[] = [];
          for (const columnDef of columnDefs) {
            filter.push({
              field: columnDef.field,
              type: 'like',
              value: searchString,
            } as Filter);
          }

          this.tableGridComponent.setFilter([filter]);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
